import React from 'react';
import GenericSelect from '../../GenericSelect/GenericSelect';
import { Option } from '../../GenericSelect/types';
import { DeviceFilterEnum } from './types';

interface DeviceSelectorProps {
  device: DeviceFilterEnum;
  setDevice: (device: DeviceFilterEnum) => void;
}

const DEVICE_OPTIONS: Option<DeviceFilterEnum>[] = [
  { value: DeviceFilterEnum.AllDevices, label: 'All devices' },
  { value: DeviceFilterEnum.Mobile, label: 'Mobile' },
  { value: DeviceFilterEnum.Desktop, label: 'Desktop' },
  { value: DeviceFilterEnum.Tablet, label: 'Tablet' },
  { value: DeviceFilterEnum.Unknown, label: 'Unknown' },
];

export const DeviceSelector = ({ device, setDevice }: DeviceSelectorProps): JSX.Element => (
  <GenericSelect<DeviceFilterEnum>
    value={device}
    onChange={event => setDevice(event.target.value as DeviceFilterEnum)}
    icon={null}
    placeholder='Device...'
    options={DEVICE_OPTIONS}
  />
);
